import BedroomsFilter from '../store/BedroomsFilter';
import FlexibleArrivalDateFilter from '../store/FlexibleArrivalDateFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import PriceFilter from '../store/PriceFilter';
import TravelPartyFilter from '../store/TravelPartyFilter';

export default class SearchFormComponentFilterMapping {
    public static mapFieldsToFilters(): Map<string, CallableFunction> {
        const filters = HouseSearchFilters.getInstance();

        return new Map([
            [
                'adults',
                (field: HTMLInputElement): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.adults = Number(field.value);
                }
            ],
            [
                'children',
                (field: HTMLInputElement): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.children = Number(field.value);
                }
            ],
            [
                'babies',
                (field: HTMLInputElement): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.babies = Number(field.value);
                }
            ],
            [
                'pets',
                (field: HTMLInputElement): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.pets = Number(field.value);
                }
            ],
            [
                'minPrice',
                (field: HTMLInputElement | HTMLSelectElement): void => {
                    const filter = filters.get(PriceFilter.NAME) as PriceFilter;
                    filter.min = Number(field.value);
                }
            ],
            [
                'maxPrice',
                (field: HTMLInputElement | HTMLSelectElement): void => {
                    const filter = filters.get(PriceFilter.NAME) as PriceFilter;
                    filter.max = Number(field.value);
                }
            ],
            [
                'flexibleArrivalDate',
                (field: HTMLInputElement): void => {
                    const filter = filters.get(
                        FlexibleArrivalDateFilter.NAME
                    ) as FlexibleArrivalDateFilter;
                    filter.flexibleRange = Number(field.value);
                }
            ],
            [
                'bedrooms',
                (field: HTMLInputElement | HTMLSelectElement): void => {
                    const filter = filters.get(BedroomsFilter.NAME) as BedroomsFilter;
                    filter.bedrooms = Number(field.value);
                }
            ]
        ]);
    }
}
